






import Breadcrumbs from '@/components/LayoutBreadcrumbs.vue';
import LoginIndicator from '@/components/LoginIndicator.vue';

import Vue from 'vue';

export default Vue.extend({
  name: 'LayoutHeader',
  components: {
    Breadcrumbs,
    LoginIndicator,
  },
});
